import React, { useState } from "react";
import { Box, Typography, MenuItem, Select, FormControl, InputLabel, Grid, Checkbox, ListItemText, OutlinedInput, Chip } from "@mui/material";
import { Button } from "@deere/fuel-react";
import { APPROVAL_LEVELS, COUNTRY_FILTER_OPTIONS } from "../utils/constants";

const SearchFilters = ({ onSearch, onClear, materialTypes }) => {
  const [filters, setFilters] = useState({
    materialType: [],
    approvalLevel: "",
    taxDepartureCountry: "",
  });

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleMaterialTypeChange = (event) => {
    const value = event.target.value;
    if (value.includes("select_all")) {
      // If all are already selected, deselect all; otherwise select all
      const allSelected = filters.materialType.length === (materialTypes?.length || 0);
      handleFilterChange("materialType", allSelected ? [] : [...(materialTypes || [])]);
    } else {
      handleFilterChange("materialType", value);
    }
  };

  const isAllSelected = materialTypes?.length > 0 && filters.materialType.length === materialTypes.length;

  const handleSearch = () => {
    onSearch({
      materialType: filters.materialType.length > 0 ? filters.materialType : null,
      approvalLevel: filters.approvalLevel || null,
      taxDepartureCountry: filters.taxDepartureCountry || null,
    });
  };

  const handleClear = () => {
    setFilters({ materialType: [], approvalLevel: "", taxDepartureCountry: "" });
    onClear();
  };

  return (
    <Box
      sx={{
        padding: "20px",
        backgroundColor: "white",
        marginBottom: "20px",
        borderRadius: 2,
        boxShadow: 3,
      }}
    >
      <Typography
        variant="h3"
        sx={{ fontWeight: "bold", marginBottom: "15px", color: "black" }}
      >
        Search Filters
      </Typography>

      <Grid container spacing={2} alignItems="flex-end">
        {/* Material Type (Multi-Select) */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Material Type</InputLabel>
            <Select
              multiple
              value={filters.materialType}
              onChange={handleMaterialTypeChange}
              input={<OutlinedInput label="Material Type" />}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, maxHeight: 60, overflow: "auto" }}>
                  {selected.slice(0, 1).map((value) => (
                    <Chip key={value} label={value} size="small" />
                  ))}
                  {selected.length > 1 && (
                    <Chip label={`+${selected.length - 1} more`} size="small" variant="outlined" />
                  )}
                </Box>
              )}
              MenuProps={{ PaperProps: { style: { maxHeight: 300 } } }}
            >
              <MenuItem value="select_all">
                <Checkbox checked={isAllSelected} indeterminate={filters.materialType.length > 0 && !isAllSelected} />
                <ListItemText primary="Select All" />
              </MenuItem>
              {materialTypes && materialTypes.map((type) => (
                <MenuItem key={type} value={type}>
                  <Checkbox checked={filters.materialType.indexOf(type) > -1} />
                  <ListItemText primary={type} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Approval Level */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Approval Level</InputLabel>
            <Select
              value={filters.approvalLevel}
              onChange={(e) => handleFilterChange("approvalLevel", e.target.value)}
              label="Approval Level"
            >
              <MenuItem value="">All</MenuItem>
              {APPROVAL_LEVELS.map((level) => (
                <MenuItem key={level.value} value={level.value}>
                  {level.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Tax Departure Country */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Country</InputLabel>
            <Select
              value={filters.taxDepartureCountry}
              onChange={(e) => handleFilterChange("taxDepartureCountry", e.target.value)}
              label="Country"
            >
              <MenuItem value="">All</MenuItem>
              {COUNTRY_FILTER_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Buttons */}
        <Grid item xs={12} sm={12} md={4} lg={3}>
          <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-start" }}>
            <Button variant="primary" onClick={handleSearch}>
              Search
            </Button>
            <Button
              variant="outlined"
              onClick={handleClear}
              sx={{
                color: "black",
                borderColor: "#CCCCCC",
                "&:hover": {
                  borderColor: "#CCCCCC",
                  backgroundColor: "#F0F0F0",
                },
              }}
            >
              Clear
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SearchFilters;
